import { useTranslation } from "react-i18next"

export const useEquipmentKitTabTranslation = () => useTranslation("operation", { keyPrefix: "vehicleEquipment.kitTab" });